var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBigFinancescomponent = function SvgWorkspaceBigFinancescomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#7BC75C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 13c0 .825-.675 1.5-1.5 1.5-.135 0-.262-.015-.383-.053l-2.67 2.663c.038.12.053.255.053.39 0 .825-.675 1.5-1.5 1.5a1.504 1.504 0 0 1-1.448-1.89l-1.912-1.912c-.12.037-.255.052-.39.052s-.27-.015-.39-.053l-3.412 3.42c.037.12.052.248.052.383 0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5.675-1.5 1.5-1.5c.135 0 .262.015.383.052l3.42-3.412a1.504 1.504 0 0 1 1.447-1.89 1.504 1.504 0 0 1 1.447 1.89l1.913 1.912c.12-.037.255-.052.39-.052s.27.015.39.052l2.662-2.67A1.275 1.275 0 0 1 21.25 13c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceBigFinancescomponent;